// extracted by mini-css-extract-plugin
export default {"backLink":"CatalogRun_backLink__iv-YM"};